const TYPE = 'rsrc.detail.SimpleImageDetail';
function create() {
  return {
    type: TYPE
  };
}
export default {
  type: TYPE,
  TYPE,
  name: 'Simple Image Detail',
  create
};